// Monochrome direction: groups are distinguished by name, not color. This stays
// as a single neutral so any remaining `--row-accent` consumers resolve to ink;
// the one signal color (amber) is reserved for the playing/active state in CSS.
export function groupColorFor() {
  return "var(--line-2)";
}

export function groupForTalkgroup(talkgroupNum, groupsData) {
  if (!Array.isArray(groupsData)) return null;
  return groupsData.find(
    (g) => Array.isArray(g.talkgroups) && g.talkgroups.includes(talkgroupNum)
  ) || null;
}

export function talkgroupNameFor(talkgroupNum, talkgroupsData) {
  if (
    !talkgroupsData ||
    !talkgroupsData.talkgroups ||
    typeof talkgroupsData.talkgroups[talkgroupNum] === "undefined"
  ) {
    return String(talkgroupNum);
  }
  return talkgroupsData.talkgroups[talkgroupNum].description;
}

export function previousCallToPlay(callsData, currentCallId) {
  if (!callsData) return null;
  const index = callsData.ids.findIndex((id) => id === currentCallId);
  if (index < 0 || index + 1 >= callsData.ids.length) return null;
  return callsData.entities[callsData.ids[index + 1]] || null;
}

function dividerLabel(date) {
  const now = new Date();
  const sameDay = date.toDateString() === now.toDateString();
  const hour = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
  const time = hour.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return sameDay ? `Today · ${time}` : `${date.getMonth() + 1}/${date.getDate()} · ${time}`;
}

export function groupCallsByDivider(callsData) {
  if (!callsData) return [];
  const buckets = [];
  let current = null;
  callsData.ids.forEach((id) => {
    const call = callsData.entities[id];
    if (!call) return;
    const label = dividerLabel(new Date(call.time));
    if (!current || current.label !== label) {
      current = { label, callIds: [] };
      buckets.push(current);
    }
    current.callIds.push(id);
  });
  return buckets;
}
